export default __webpack_public_path__ + "static/media/ecSensorTemp.cc0687c6.svg";